import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import {
  RF_PROFILE_SETUP,
  RF_DEVICE_REGISTRATION,
} from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
import { doubleEncode } from '../../../../Utils/Encode/UrlHelper';
/**
 * list RF Profile Setups.
 * @returns {Promise} - A promise that resolves with the list of RF Profile Setups or rejects with an error.
 * @param props
 */
export const listRFProfileSetup = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
  profile,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };
  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_SETUP}/filter?ProfileId=${profile?.SRFProfileId}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    ProfileSetups: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create RF Profile Setup .
 * @returns {Promise} - A promise that resolves with the creation of RF Profile Setup or rejects with an error.
 * @param data
 */
export const createRFProfileSetup = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_SETUP}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update RF Profile Setup.
 * @returns {Promise} - A promise that resolves with the update of RF Profile Setup or rejects with an error.
 * @param data
 */
export const updateRFProfileSetup = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_SETUP}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Delete RF Profile Setup.
 * @returns {Promise} - A promise that resolves with the update of RF Profile Setup or rejects with an error.
 * @param data
 */
export const deleteRFProfileSetup = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_SETUP}/${doubleEncode(data?.SRFProfilesSetupId)}?profileSetupId=${data?.SRFProfilesSetupId}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};
/**
 * Get RF Profile Setup.
 * @returns {Promise} - A promise that resolves with the update of RF Profile Setup or rejects with an error.
 * @param data
 */
export const getRFProfileSetup = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_PROFILE_SETUP}/${doubleEncode(data?.SRFProfilesSetupId)}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
/**
 * getDeviceRegistrationStatus.
 * @param {string} profileSetupId - The ID of the profile setup.
 * @returns {Promise} - A promise that resolves with the generated QR code or rejects with an error.
 */
export const getDeviceRegistrationStatus = async ({ profileSetupId }) => {
  const { accessToken } = getTokensFromStorage();
  const queryParams = new URLSearchParams({
    ProfileSetupId: profileSetupId,
  });
  const routeName = `${RF_DEVICE_REGISTRATION}/Status?${queryParams.toString()}`;

  let response = await apiServiceWrapper({
    url: routeName,
    method: 'POST',
    accessToken,
    headers: { 'X-Client-Sub-Module': 'Status' },
  });
  return response;
};
